<template>
  <main>
    <BrandedLogo />
    <router-view />
    <PoweredByLogo />
  </main>
</template>

<script>
  import { computed, defineComponent, onMounted } from 'vue';
  import authApi from './authApi';
  import { useRandomizedBackground } from '@/components/useRandomizedBackground';
  import BrandedLogo from '@/modules/branding/components/BrandedLogo';
  import PoweredByLogo from '@/modules/branding/components/PoweredByLogo';
  import { useRouter } from '@/router';
  import { useStore } from '@/store';

  export default defineComponent({
    name: 'App',
    components: {
      BrandedLogo,
      PoweredByLogo
    },
    setup () {
      const { currentRoute } = useRouter();
      const store = useStore();
      // TODO: This needs to be updated to use abstractions instead of window/document
      const randomizedBackground = useRandomizedBackground({
        storage: window.localStorage,
        document: window.document
      });
      const template = computed(() => store.state.branding.isBranded
        ? store.state.branding.branding.code
        : null);

      onMounted(async () => {
        await store.dispatch('branding/fetchBranding', currentRoute.query?.brand_template);
        randomizedBackground.init(template.value);
        // Ensure the user has a CSRF token even if they entered directly
        // through the static site. This will do nothing if the user entered
        // through a server-side entry point.
        authApi.get('xsrf');
      });
    }
  });
</script>

<style lang="scss">
  @use '@/styles/modules/palette';

  html {
    height: 100%;
  }

  body {
    margin: 0;
    min-height: 100%;
    background-color: palette.$primary8-color;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  main {
    width: 100%;
  }

  main > section {
    position: relative;
    background-color: palette.$neutral1-color;
    border-radius: 10px;
    box-shadow: 0 -2px 20px palette.$effect-card-shadow-color;
    margin: 0 auto;
    margin-bottom: 15px;
    padding: 48px;
    width: 100%;
    max-width: 600px;

    > .loading-indicator {
      border-radius: 10px;
    }
  }

  .main-button-container {
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    margin-top: 24px;

    > * {
      flex-grow: 1;
    }

    .link-container > * {
      display: block;
      margin: 8px 0;

      &:first-child {
        margin-top: 0;
      }
    }
  }

  @media (max-height: 600px) {
    main {
      position: inherit;
      top: 0;
      transform: none;
    }
  }
</style>
